import DashboardLayout from "@/pages/Dashboard/DashboardLayout/DashboardLayout";
import ChatPage from "@/pages/Dashboard/Pages/ChatPage/ChatPage";
import CarrouselClientesPage from "@/pages/Dashboard/Pages/ConfiguracionPage";
import DevPage from "@/pages/Dashboard/Pages/DevPage";
import PreciosMainPage from "@/pages/principal/PreciosMainPage";
import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import RequireUser from "../components/Auth/requireUser";
import LoginPage from "../pages/Auth/login.page";
import RecoverPage from "../pages/Auth/recover.page";
import RegisterPage from "../pages/Auth/register.page";
import ResetPasswordPage from "../pages/Auth/reset-password.page";
import UnauthorizePage from "../pages/Auth/unauthorize.page";
import FiltrarInformesPage from "../pages/Dashboard/Pages/FiltrarInformes/FiltrarInformesPage";
import PapeleraPage from "../pages/Dashboard/Pages/PapeleraPage";
import UsuariosPage from "../pages/Dashboard/Pages/UsuariosPage";
import Layout from "../pages/Layout/Layout";
import ProfileLayout from "../pages/Profile/ProfileLayout";
import AboutUs from "../pages/principal/AboutUs";
import ContactPage from "../pages/principal/ContactPage";
import InformePageLayout from "../pages/principal/Informes/InformePageLayout";
import MainPage from "../pages/principal/MainPage/MainPage";
import { listaDeInformes } from "./listaDeInformes";
import LogsErrorPage from "@/pages/Dashboard/Pages/LogsErrorPage";
import VerEmpresasPage from "@/pages/Dashboard/Pages/Empresas/Ver/VerEmpresasPage";

const CarritoPage = lazy(() => import("../pages/Carrito/CarritoPage"))
const VerificarEmailPage = lazy(() => import("../pages/Auth/verificarEmailPage"))
const InformePage = lazy(() => import("../pages/principal/Informes/InformePage"))


const DashboardPage = lazy(() => import("../pages/Dashboard/Pages/DashboardPage"))
const CarritosPage = lazy(() => import("../pages/Dashboard/Pages/Carpetas/CarpetasPage/CarritosPage"))
const PreciosPage = lazy(() => import("../pages/Dashboard/Pages/PreciosPage"));

const CrearEmpresaPage = lazy(() => import("../pages/Dashboard/Pages/Empresas/Crear/CrearEmpresaPage"))

const SiteRoutes = () => {


    return (

        <Routes>
            <Route element={<Layout />}>
                <Route index element={<MainPage />} />
                <Route element={<RequireUser allowedRoles={['user', 'admin', 'dev']} />}>
                    <Route path='perfil' element={<ProfileLayout />}>
                        <Route path=':profilePage' element={<ProfileLayout />} />
                    </Route>
                </Route>
                <Route path="*" element={<MainPage />} />
                <Route path='unauthorized' element={<UnauthorizePage />} />
                <Route path='login' element={<LoginPage />} />
                <Route path='register' element={<RegisterPage />} />
                <Route path='empresa' element={<AboutUs />} />
                <Route path='precios' element={<PreciosMainPage />} />
                <Route path='clientes' element={<div>clientes</div>} />
                <Route path='contacto' element={<ContactPage />} />
                <Route path='verificaremail' element={<MainPage />} />
                <Route path='verificaremail/:codigo' element={<VerificarEmailPage />} />

                <Route path='recuperarcuenta' element={<RecoverPage />} />

                <Route path='resetpassword' element={<ResetPasswordPage />}>
                    <Route path=':resetToken' element={<ResetPasswordPage />} />
                </Route>
                <Route path='carrito' element={<CarritoPage />} />
                <Route element={<InformePageLayout />} path='informe'>
                    {listaDeInformes.map((informe) => {
                        return <Route key={informe.path} path={informe.path} element={<InformePage mapInforme={informe.ComponentName} />} />
                    })}
                </Route>
            </Route>
            <Route element={<RequireUser allowedRoles={['admin', 'dev']} />}>
                <Route element={<DashboardLayout />} path='dashboard'>
                    <Route index element={<DashboardPage />} />
                    <Route path="carpetas" element={<CarritosPage />} key={'informesPageKey'} />
                    <Route path="filtrarInformes" element={<FiltrarInformesPage />} key={'informesPageFilterKey'} />
                    <Route path="usuarios" element={<UsuariosPage />} key={'usuariosPageKey'} />
                    <Route path="precios" element={<PreciosPage />} key={'preciosPageKey'} />
                    <Route path="papelera" element={<PapeleraPage />} key={'PapeleraPageKey'} />
                    <Route path="configuracionGeneral" element={<CarrouselClientesPage />} key={'configuracionGeneralPageKey'} />
                    <Route path="empresas/crear" element={<CrearEmpresaPage />} key={'crearEmpresaPageKey'} />
                    <Route path="empresas/ver" element={<VerEmpresasPage />} key={'verEmpresasPageKey'} />

                    <Route element={<RequireUser allowedRoles={['dev']} />}>
                        <Route path="chat" element={<ChatPage />} key={'ChatPageKey'} />
                        <Route path="dev" element={<DevPage />} key={'DevPageKey'} />
                        <Route path="errors" element={<LogsErrorPage />} key={'logErrorPage'} />
                    </Route>
                </Route>
            </Route>

        </Routes>



    );
}

export default SiteRoutes;